import * as SubOfProjectTypeActionType from './constants';
import * as CommonActionType from 'Common/constants';
import * as ProjectActionType from 'Projects/constants';

const defaultParams = {
  projectId: '',
  phaseId: '',
  tradeId: '',
  subcontractorId: '',
  skip: 1,
  take: 10,
  sort: { field: 'projectName', order: 'ascending' },
  totalRecord: 0,
  totalPage: 0
};

const ManageSubAssignmentToProjects = {
  items: [],
  params: defaultParams
};

const SubAssignmentToProjectState = {
  ManageSubAssignmentToProjects: ManageSubAssignmentToProjects,
  SelectListProjects: [],
  SelectListTrades: [],
  SelectListSubcontractors: []
};

export default function SubAssignmentToProjectStore(state = SubAssignmentToProjectState, action) {
  switch (action.type) {
    case SubOfProjectTypeActionType.SEARCH_SUBCONTRACTOR_ASSIGNMENT_TO_PROJECT_SUCCESS:
      return processSearchSuccess(state, action);
    case CommonActionType.COMMON_SELECT_LIST_ITEM_TRADE_SUCCESS:
      return processSelectListTrades(state, action);
    case CommonActionType.COMMON_SELECT_LIST_SUBCONTRACTOR_SUCCESS:
      return processSelectListSubcontractors(state, action);
    case ProjectActionType.SELECT_LIST_PROJECT_SUCCESS:
      return processSelectListProjects(state, action);
    case SubOfProjectTypeActionType.RESET_SUBCONTRACTOR_ASSIGNMENT:
      return {
        ...state,
        ManageSubAssignmentToProjects: ManageSubAssignmentToProjects
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {

  var result = action.data;

  var manageSubAssignmentToProjects = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };

  return {
    ...state,
    ManageSubAssignmentToProjects: manageSubAssignmentToProjects
  };
};

const processSelectListTrades = (state, action) => {

  return {
    ...state,
    SelectListTrades: action.data
  };
};

const processSelectListSubcontractors = (state, action) => {

  return {
    ...state,
    SelectListSubcontractors: action.data
  };
};

const processSelectListProjects = (state, action) => {

  return {
    ...state,
    SelectListProjects: action.data
  };
};



// WEBPACK FOOTER //
// ./src/Subcontractors/sub-assignment-to-project-store.js